import Vue from 'vue'

const state = {
  user: null,
  moderator: false,
}

const getters = {}

const mutations = {
  SET_USERS_STATE(state, payload) {
    for (var key in payload) if (key in state) Vue.set(state, key, payload[key])
  },
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}
